"use client";

import { usePathname } from "next/navigation";
import { useRef } from "react";

import { isDialogPathname } from "@/utils/dialog-routes";

export const useBackgroundPathname = () => {
  const pathname = usePathname();
  const backgroundPathnameRef = useRef(pathname);

  if (!isDialogPathname(pathname)) {
    backgroundPathnameRef.current = pathname;
  }

  return isDialogPathname(pathname) ? backgroundPathnameRef.current : pathname;
};
